import React, { useState } from 'react';
import { Button, Stack } from '@mui/material';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import './Survey.css';

export const SurveyBtns = ({ questionCategory, question, questionAnswer }) => {
  const [selectedAnswer, setSelectedAnswer] = useState();

  const handleSelectedAnswer = (answer) => {
    setSelectedAnswer(answer);
    questionAnswer(question, answer);
  };

  const getButtonStyle = (answer) => {
    return selectedAnswer === answer ? 'answerSelected' : 'answerBtn';
  };

  return (
    <Stack direction="row" spacing={2} id="btnAnswers">
      {questionCategory.map((answer, index) => (
        <Button
          sx={{ width: '300px', fontSize: '12px', height: '50px' }}
          variant="outlined"
          key={index}
          id={getButtonStyle(answer)}
          onClick={() => handleSelectedAnswer(answer)}
          startIcon={<CircleOutlinedIcon className="circleIcon" />}
        >
          {answer}
        </Button>
      ))}
    </Stack>
  );
};
